class APIS {
	apis() {
		return {
			getSettings: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/backend/phone-validation/settings'
			},
			updateSettings: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/phone-validation/settings'
			},
			deleteSettings: {
				headers: {
					'xt-user-token': null
				},
				method: 'delete',
				path: '/backend/phone-validation/settings'
			}
		};
	}
}

export default new APIS();
